<template>
  <div class="accredit">
    <a-spin :spinning="loading">
      <template v-if="data?.id">
        <Result
          v-if="showSuccess"
          :show-success="showSuccess"
          :sige-info="sigeInfo"
          @back="goBack"
        />
        <div v-else class="unauthorized">
          <div class="title">
            {{ $t('mo-fa-you-yan-zuo-pin-shi-yong-shou-quan-shu') }}
          </div>
          <div class="picture w-[1200px] pb-[103px] mt-[50px]">
            <img :src="sigeInfo?.authorization_certificate_file_url" class="w-full h-full" />
          </div>
          <div v-if="data?.is_my_sign_record" class="footer">
            <div class="flex gap-[24px] justify-center">
              <a-button
                v-if="data?.status && data?.status !== ACCREDIT_STATUS.WAIT"
                type="primary"
                size="large"
                disabled
                class="min-w-[108px] !h-[43px] !text-[16px] !leading-4"
              >
                {{
                  data?.status === ACCREDIT_STATUS.SUCCESS
                    ? $t('yi-qian-shu')
                    : $t('yi-ju-jue-qian-shu')
                }}
              </a-button>
              <template v-else>
                <a-button
                  type="primary"
                  ghost
                  size="large"
                  class="min-w-[108px] !h-[43px] !text-[16px] !leading-4"
                  @click="open"
                >
                  {{ $t('ju-jue-qian-shu') }}
                </a-button>
                <a-button
                  type="primary"
                  size="large"
                  class="min-w-[108px] !h-[43px] !text-[16px] !leading-4"
                  @click="onOk"
                >
                  {{
                    sigeInfo?.reward_coin
                      ? $t('tong-yi-qian-shu-ling-qu-x-yan-bi', [sigeInfo?.reward_coin])
                      : $t('tong-yi-qian-shu')
                  }}
                </a-button>
              </template>
            </div>
          </div>
        </div>
      </template>
      <div v-else-if="data?.noData" class="success">
        <div class="flex flex-col items-center justify-center">
          <iconpark-icon name="iconwarn" size="56"></iconpark-icon>
          <div class="text-font-1 text-[20px] mt-[20px]">
            {{ $t('dang-qian-shou-quan-xin-xi-yi-shi-xiao') }}
          </div>
          <a-button size="large" type="primary" class="mt-[30px]" @click="goBack">
            {{ $t('guan-bi-ye-mian') }}
          </a-button>
        </div>
      </div>
    </a-spin>
    <CheckModal ref="checkRef" @submit="submit" />
  </div>
</template>

<script lang="ts" setup>
import CheckModal from './components/checkModal.vue';
import Result from './components/result.vue';
import { PageKey } from '~/constants/page';
import { getAccreditResult, putAccreditResult } from '~/api/index';
import { ACCREDIT_STATUS } from '~/api/interface/index';

const checkRef = ref();
const showSuccess = ref<'reject' | 'agree' | ''>('');
const route = useRoute();
const userInfo = useUserInfo();
const ID = Number(route.params.id);
const { $t } = useNuxtApp();
const router = useRouter();
const data = ref();
const loading = ref(false);

const sigeInfo = computed(() => data.value?.sign_info);

const fetchData = async () => {
  try {
    loading.value = true;
    const res = await getAccreditResult({
      id: ID,
    });
    if (res.data) {
      data.value = res.data?.[0] || { noData: true }; // 当前数据不存在
      loading.value = false;
    }
  } catch (error) {
    loading.value = false;
  }
};

useAsyncData(fetchData);

watch(
  () => userInfo.value?.user_id,
  (cur, before) => {
    if (cur !== before && cur) {
      fetchData();
    } else {
      goHome();
    }
  },
);

const open = () => {
  checkRef.value.toggle();
};

const goBack = () => {
  window?.close();

  goHome();
};

const onOk = () => {
  submit({ status: ACCREDIT_STATUS.SUCCESS });
};

const submit = async (params: { status: ACCREDIT_STATUS; refuse_reason?: string }) => {
  const res = await putAccreditResult({ ...params, id: ID });

  if (!res.code && res.data) {
    if (params.status === ACCREDIT_STATUS.SUCCESS) {
      showSuccess.value = 'agree';
    } else {
      showSuccess.value = 'reject';
      checkRef.value.toggle();
    }
  }
};
</script>

<style lang="scss" scoped>
.accredit {
  @apply h-full;
  :deep(.ant-spin-nested-loading) {
    height: 100%;
  }
  :deep(.ant-spin-container) {
    height: 100%;
  }
  .unauthorized {
    @apply flex flex-col items-center;
  }
  .success {
    @apply flex flex-col h-full items-center justify-center;
  }
  .title {
    @apply p-[12px_31px] mt-[90px];
    display: inline-block;
    font-size: 32px;
    text-align: center;
    font-weight: bold;
    letter-spacing: 2px;
    background: linear-gradient(117deg, #5625ff 0%, #121926 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    border-radius: 12px;
    border: 1px solid var(--purple-6);
  }
  .footer {
    @apply fixed bottom-0 py-[30px] w-full left-0 text-center;
    box-shadow: var(--accredit-footer-shadow);
    background: var(--accredit-footer-bg);
  }
}
</style>
